import React from "react";
import api from "../../../../api/quiz";
import {tempconnectList} from "../../../../api/tempdata";

const initialData = {
  itemsList: []
};

export default function useProgramConnect() {
  const [connectsData, setConnectsData_] = React.useState(initialData);

  const setConnectsData = newData => {
    const newConnectsData = {
      ...connectsData,
      ...newData
    };

    setConnectsData_(newConnectsData);
  };

  function getConnects(id) {
    setConnectsData({itemsList: tempconnectList});
    //api.getQuizList().then(({ data }) => setRequestsData({ quizList: data }));
  }

  return { connectsData, getConnects};
}
